/* RESPONSIBLE TEAM: team-ai-insights */

import { TrendingTopicImpact, TrendingTopicTimeTrend } from './trending-topics-data-resources';
import type IntlService from 'ember-intl/services/intl';
import { insightsMetrics } from 'embercom/components/reporting/automation/ai-insights/fin-insights/jobs';
import PALETTE from '@intercom/pulse/lib/palette';

const IMPACT_TRANSLATION_KEY_MAP: Record<TrendingTopicImpact, string> = {
  [TrendingTopicImpact.Positive]: 'positive',
  [TrendingTopicImpact.Negative]: 'negative',
  [TrendingTopicImpact.Neutral]: 'neutral',
  [TrendingTopicImpact.Unknown]: '',
};

const TIME_TREND_TRANSLATION_KEY_MAP: Record<TrendingTopicTimeTrend, string> = {
  [TrendingTopicTimeTrend.IncreasingTrend]: 'increasing-trend',
  [TrendingTopicTimeTrend.DecreasingTrend]: 'decreasing-trend',
  [TrendingTopicTimeTrend.Flat]: 'flat-trend',
  [TrendingTopicTimeTrend.SingleWeekAnomaly]: 'event',
  [TrendingTopicTimeTrend.Unknown]: '',
};

function volumeMetricConfig(intl: IntlService) {
  let { metric_id, aggregation, label } = insightsMetrics(intl).volume;
  return {
    palette: [],
    colorAxis: { stops: [] },
    seriesConfig: {
      metric_id,
      aggregation,
      color: PALETTE['vis-mustard-40'],
    },
    metricPickerItemClass: 'bg-vis-mustard-40',
    tooltipMetricColorClass: 'reporting__text-vis-mustard-40',
    label,
  };
}

export { IMPACT_TRANSLATION_KEY_MAP, TIME_TREND_TRANSLATION_KEY_MAP, volumeMetricConfig };
